import React, {useState, useEffect, useRef} from 'react';
import AppCartItem from "./app.cart.item";
import AppCartInfo from "./app.cart.info";
import {gql, useLazyQuery, useReactiveVar} from "@apollo/client";
import {cartTotal} from "../config/react.vars";
import 'animate.css';

const QUERY_GET_PRESENT = gql`
        query getPresent($id: String){
            getPresent(id: $id){
                id
                quantity
                id_presence
            }
    }
`;

const __env = window.__env || null;
const { id, title, additional_info, price } = __env.product;

const evt = new StorageEvent('storage', {
    key: 'items',
    oldValue: 'oldValue',
    newValue: 'newValue',
    url: null,
    storageArea: window.localStorage
});

// Описываем работу с localStorage (этот никак не связано с react)
const dispatch = (action) => {
    let items = JSON.parse(localStorage.getItem('cartItems'));
    if(!items) items = [];

    let index = items.findIndex(el => el.id === id);

    switch (action.type) {
        case 'add':
            items.push(action.payload);
        break;
        case 'update':{
            console.log('product-cart-button increase update');
            items.splice(index, 1, action.payload);   
        }
        break;
        case 'delete':
            items.splice(index, 1);
        break;
    }
    localStorage.setItem('cartItems', JSON.stringify(items));
    //console.log('before dispatch');
    window.dispatchEvent(evt);
    //console.log('after dispatch');
}

const AppProductCartButtonMain = () => {

    const [product, setProduct] = useState(false);

    useEffect(() => {
       
    }, [])

    const [getProductPresent, {
        loading: prodLoading,
        error: prodError,
        data: prodData,
    }] = useLazyQuery(QUERY_GET_PRESENT, {notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: {id: id, public:true }});



    useEffect(() => {
        getProductPresent();
    }, [id])

    useEffect(() => {
        if (!prodLoading) {
            if (!prodError) {
                if (prodData && prodData.getPresent) {

                    let prodt = {};
                    if(prodData.getPresent) {
                        for (let prop in prodData.getPresent) {
                            prodt[prop] = prodData.getPresent[prop];
                        }

                        if (!prodt.id_presence) {
                            prodt.id_presence = 0;
                        }

                    }else{
                        prodt = prodData.getPresent;
                    }
                    console.log('getPresent: ',prodt );
                    setProduct(prodt);
                }
            }
        }
    }, [prodLoading]);


    const [ item, setItem ] = useState(null);



    useEffect(() => {
        const itemsCart = JSON.parse(localStorage.getItem('cartItems'));
        if (!itemsCart) return;

        const foundItemIndex = itemsCart.findIndex(el => el.id === id);
        if (foundItemIndex === -1) return;

        setItem(itemsCart[foundItemIndex]);

        // Добавляем глобальное слушатель события об изменении cartItems в localStorage
        window.addEventListener('storage', function (e) {

            const itemsCart = JSON.parse(localStorage.getItem('cartItems'));
            if (!itemsCart) {
                setItem(null);
                return;
            }

            const foundItemIndex = itemsCart.findIndex(el => el.id === id);
            if (foundItemIndex === -1){
                setItem(null);
                return;
            }

            setItem(itemsCart[foundItemIndex]);
        });
    }, []);

    const increaseCount = (e) => {

        let itemCount = 0;

        if(product){
            itemCount = product.quantity;
            if((itemCount ===0) && (product.id_presence === 2)){
                itemCount = 1;
            }
        }
        

        if (!item) {
            if (itemCount>0) {
                const defaultItem = {
                    id,
                    title,
                    additional_info,
                    price: Number(price),
                    count: 1,
                    checked: true
                };
                setItem(defaultItem);
                dispatch({type: 'add', payload: defaultItem});
            }else{
                // тут эффект: не добавляем в корзину
                animationEffect(e);
            }
        } else {
            let count = item.count;
            if (count+1<=itemCount) {
                count ++;
                item.count += 1;
                setItem({...item, count});
                dispatch({type: 'update', payload: item});
            }else{
                //тут бы эффект: не увеличиваем
                animationEffect(e, 'rotateIn');
            }
        }

    }

    const animationEffect = (e, mode) => {
        mode = mode || 'shakeX';
        console.log("tagName: "+e.target.tagName);
        let step = 0;
        let btn = e.target;
        let tagname = btn.tagName;
        while(tagname!='BUTTON' && step<5){
            step++;
            btn = btn.parentNode;
            tagname = btn.tagName;
            console.log("btn: "+tagname);
        }
        let lst = btn.classList;

        if(! lst.contains('animate__animated')){
            lst.add('animate__animated');
        }
        if(! lst.contains('animate__shakeX')){
            lst.add('animate__'+mode);
        }
        let tmr = setTimeout( ()=>{
            lst.remove('animate__animated');
            lst.remove('animate__'+mode);
        }, 1000)
    }

    const decreaseCount = () => {
        if (item.count === 1) {
            setItem(null);
            dispatch({ type: 'delete' });
        } else {
            let count = item.count -= 1;
            setItem({ ...item, count });
            dispatch({ type: 'update', payload: item });
        }
    }

    return (
        <div className="btn-cart my-5">

            {!item ? (
                <button type="button" className="btn btn-carbonus" onClick={increaseCount}>
                    <svg className="d-inline-block align-top me-2" width="24" height="24">
                        <use xlinkHref="#icon-cart"/>
                    </svg>
                    <span>В корзину</span>
                </button>
            ) : (
                <div className="row gx-1">
                    <div className="col">
                        <a href="/cart" className="btn btn-carbonus btn-cart-link">
                            <span style={{fontWeight:"bold", whiteSpace:"nowrap"}}>В корзине</span>перейти
                        </a>
                    </div>
                    <div className="col">
                        <div className="form-control">
                            <button type="button"
                                    className="btn w-auto flex-shrink-0 px-2"
                                    aria-label="Убрать"
                                    onClick={decreaseCount}
                            >
                                <svg className="d-block" width="24" height="24">
                                    <use xlinkHref="#icon-minus"/>
                                </svg>
                            </button>
                            <div className="flex-grow-1 text-center">{item.count}</div>
                            <button type="button"
                                    className={"btn w-auto flex-shrink-0 px-2"+(prodLoading?" border-0":'')}
                                    aria-label="Добавить"
                                    onClick={increaseCount} disabled={prodLoading}
                            >
                                <svg className="d-block" width="24" height="24">
                                    <use xlinkHref="#icon-plus"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="row gx-4 mt-4">
                <div className="col-auto">
                    <svg className="d-block" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.29 5.89L11.29 15.89C10.9 16.28 10.27 16.28 9.87998 15.89L7.04998 13.06C6.65998 12.67 6.65998 12.04 7.04998 11.65C7.43998 11.26 8.06998 11.26 8.45998 11.65L10.58 13.77L19.87 4.48C20.26 4.09 20.89 4.09 21.28 4.48C21.68 4.87 21.68 5.5 21.29 5.89ZM15.77 2.74C14.08 2.05 12.16 1.81 10.16 2.17C6.08998 2.9 2.83998 6.18 2.14998 10.25C1.00998 17 6.62998 22.78 13.34 21.91C17.3 21.4 20.62 18.45 21.66 14.6C22.06 13.13 22.1 11.71 21.87 10.38C21.74 9.58 20.75 9.27 20.17 9.84C19.94 10.07 19.84 10.41 19.9 10.73C20.12 12.06 20.02 13.48 19.38 14.99C18.22 17.7 15.7 19.69 12.77 19.96C7.66998 20.43 3.43998 16.11 4.06998 10.98C4.49998 7.44 7.34998 4.56 10.88 4.07C12.61 3.83 14.25 4.16 15.65 4.88C16.04 5.08 16.51 5.01 16.82 4.7C17.3 4.22 17.18 3.41 16.58 3.1C16.31 2.98 16.04 2.85 15.77 2.74Z"></path>
                    </svg>
                </div>
                <div className="col">
                    <div>
                        {prodLoading &&
                            <> Запрос количества

                            <div className="spinner-border text-secondary ms-2" role="status" style={{'width':'16px','height':'16px'}}>
                                <span className="visually-hidden"></span>
                            </div>
                            </>
                        }
                        {!prodLoading && product &&
                            <span className="">
                                {/*product.id_presence = 0*/}
                                {/*ошибка определения наличия товара*/}
                                {(product.id_presence === 0) &&
                                    <>Под заказ</>
                                }


                                {/*product.id_presence = 1*/}
                                {/*товар в наличии, но может закончиться*/}
                                {(product.id_presence === 1) && (product.quantity > 0) &&
                                    <>В наличии {product.quantity} шт.</>
                                }
                                {(product.id_presence === 1) && (product.quantity <= 0) &&
                                    <>Под заказ</>
                                }

                                {/*product.id_presence = 2*/}
                                {/*товар под заказ, количество неизвестно, можно только 1 шт. заказать*/}
                                {(product.id_presence === 2) && (product.quantity > 0) &&
                                    <>Под заказ {product.quantity} шт.</>
                                }

                                {(product.id_presence === 2) && (product.quantity === 0) &&
                                    <>Под заказ 1 шт</>
                                }

                                {(product.id_presence === 2) && (product.quantity < 0) &&
                                    <>Под заказ</>
                                }

                            </span>
                        }
                    </div>
                    {/*<!--a href="" className="btn btn-sm btn-light border mt-2">Проверить наличие</a-->*/}
                </div>
            </div>


        </div>
    );

}

export default AppProductCartButtonMain;
